import React from "react";
import FormItem from "components/fields/FormItem";
import { DatePicker, Form, Input } from "antd";
import SelectOption from "components/select/SelectOption";
import { requiredField } from "utils/crudSagaHelper";

import TextArea from "antd/es/input/TextArea";
import DynamicList from "components/fields/DynamicList";
import AIButton from "components/ai/aibutton";
import { InputNumber } from 'antd';
import { getLabel } from "utils";
import {
    Briefcase,
    Building2,
    Award,
    FileText,
    Clock,
    Calendar,
    Users,
} from "lucide-react";


const JobRoleRequestFormFields = ({ recordData, mode, ...props }) => {

	return (
        <div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <FormItem
                    label="Status"
                    name="jrr_status_id"
                    rules={[requiredField()]}
                >
                    {mode !== 'view' ?
                        <SelectOption
                            placeholder="Select Status"
                            options={recordData?.jobRequestStatusList}
                            size="large"
                        />
                        :
                        <label className="text-base label-value dark:text-white">
                            {getLabel(recordData?.jobRequestStatusList, recordData?.jrr_status_id)}
                        </label>
                    }
                </FormItem>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <FormItem
                    label="Position Title"
                    name="jro_job_title"
                    icon={Briefcase}
                    rules={[requiredField()]}
                >
                    {mode !== 'view' ?
                    <Input
                        id="jro_job_title"
                        className="input-field"
                        placeholder="e.g., Senior Software Engineer" />
                    :
                    <label className="text-base label-value dark:text-white">
                        {recordData?.job_role?.jro_job_title}
                    </label>
                    }
                </FormItem>
                <FormItem
                    label="Department *"
                    name="jrr_department_id"
                    icon={Building2}
                    rules={[requiredField()]}
                >
                    {mode !== 'view' ?
                    <SelectOption
                        placeholder="Select Department"
                        options={recordData?.departmentList}
                        size="large"
                    />
                    :
                    <label className="text-base label-value dark:text-white">
                        {getLabel(recordData?.departmentList, recordData?.jrr_department_id)}
                    </label>
                    }
                </FormItem>
                <FormItem
                    label="Urgency Level"
                    name="jrr_priority_id"
                    icon={Clock}
                >
                    {mode !== 'view' ?
                    <SelectOption
                        placeholder="All Stages"
                        options={recordData?.priorityList}
                        size="large"
                    />
                    :
                    <label className="text-base label-value dark:text-white">
                        {getLabel(recordData?.priorityList, recordData?.jrr_priority_id)}
                    </label>
                    }
                </FormItem>
                <FormItem
                    label="Preferred Start Date *"
                    name="jrr_target_date"
                    icon={Calendar}
                    rules={[requiredField()]}
                    >
                        {mode !== 'view' ?
                        <DatePicker
                            variant="borderless"
                            className="w-full bg-gray-50 rounded-lg flex items-center px-2"
                            showSearch
                            size="large"
                        />
                        :
                        <label className="text-base label-value dark:text-white">
                            {recordData?.jrr_target_date}
                        </label>
                        }
                </FormItem>
                <div className="flex w-full gap-2 items-center">
                    <FormItem
                        label="Budget Range (Annual)"
                        name="jrr_budget_range"
                        icon={Award}
                        rules={[requiredField()]}
                        extra="w-full"
                    >
                        {mode !== 'view' ?
                        <Input
                            id="jrr_budget_range"
                            placeholder="e.g., $80,000 - $120,000 AUD"
                            className="input-field"
                            suffix="/Staff"
                        />
                        :
                        <label className="text-base label-value dark:text-white">
                            {recordData?.jrr_budget_range}
                        </label>
                        }
                    </FormItem>
                </div>
                <FormItem
                    label="Headcount"
                    name="jrr_count"
                    icon={Users}
                    rules={[requiredField()]}
                >
                    {mode !== 'view' ?
                    <InputNumber id="jrr_count" 
                        size="large" 
                        min={1} 
                        max={1000}
                        defaultValue={1} 
                        className="input-field w-[100px] mt-4"
                    />
                    :
                    <label className="text-base label-value dark:text-white">
                        {recordData?.jrr_count}
                    </label>
                    }
                </FormItem>
                <div className="md:col-span-2">
                    <FormItem
                        label="Role Requirements & Responsibilities"
                        name="jrr_job_requirements"
                        icon={FileText}
                        rules={[requiredField()]}
                    >
                        <TextArea
                            className="input-field"
                            placeholder="Describe the key requirements, responsibilities, and qualifications for this role..." 
                            rows={10}
                            maxLength={255}
                            readOnly={mode === 'view'}
                        />
                    </FormItem>
                </div>
                <div className="md:col-span-2">
                    <DynamicList 
                        name="jro_preferred_qualifications"
                        label="Preferred Skills"
                        placeholder="Enter skills"
                        addButtonClass="text-gray-500 dark:text-white"
                        mode={mode}
                        icon={FileText}
                        recordData={recordData?.job_role?.jro_preferred_qualifications}
                        listClass="list-2-column"
                    />
                </div>
            </div>
        </div>
	);
};

export default JobRoleRequestFormFields;